export interface TxtConfig {}

export const Txt: React.FC<TxtConfig> = ({}) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="19.2" height="24" viewBox="0 0 19.2 24">
      <path id="icon-txt" d="M16,2H6.4A2.4,2.4,0,0,0,4.012,4.4L4,23.6A2.4,2.4,0,0,0,6.388,26H20.8a2.407,2.407,0,0,0,2.4-2.4V9.2Zm2.4,19.2H8.8V18.8h9.6Zm0-4.8H8.8V14h9.6Zm-3.6-6V3.8l6.6,6.6Z" transform="translate(-4 -2)" fill="#b1b1b1"/>
    </svg>
  )
}
